module.exports = __webpack_public_path__ + "img/newPaintingPav8m.ee4579b6.png";